module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-products"
  }, [(_vm.products) ? _c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.products), function(product) {
    return _c('router-link', {
      staticClass: "list-group-item",
      attrs: {
        "to": _vm.getRouteParams(product)
      }
    }, [_vm._v("\n      " + _vm._s(product.name) + " "), _c('span', {
      staticClass: "badge"
    }, [_vm._v(_vm._s(product.counter))])])
  }), 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5d1d2302!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ListProductsMenu.vue
// module id = 304
// module chunks = 1